import { render, staticRenderFns } from "./CheckCard.vue?vue&type=template&id=4b8526bc&scoped=true&"
import script from "./CheckCard.vue?vue&type=script&lang=ts&"
export * from "./CheckCard.vue?vue&type=script&lang=ts&"
import style0 from "./CheckCard.vue?vue&type=style&index=0&id=4b8526bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8526bc",
  null
  
)

export default component.exports